import { render, staticRenderFns } from "./UserPlaylistCourses.vue?vue&type=template&id=388d849e"
import script from "./UserPlaylistCourses.vue?vue&type=script&lang=js"
export * from "./UserPlaylistCourses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports